export default "__VITE_ASSET__DbgolIbD__"